import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Calculator, CheckCircle, AlertTriangle, FileText, Shield, Coins} from 'lucide-react';
import EnvoiSignatureModal from './EnvoiSignatureModal';
import ResultatsMontants from './ResultatsMontants';
import ResultatsAdminPanels from './ResultatsAdminPanels';
import ResultatsActions from './ResultatsActions';

export default function ResultatsSection(props) {
  const {
  resultat, modeCalcul, modeSimulateur, user,
  formData, contratParent,
  walletBalance, creditCostPdf, hasEnoughCredits,
  loadingDevis, handleDownloadDevisSimulation,
  handleSouscrire, handleCreerAvenant,
  propositionConversion, handleSouscrireFromProposition, dismissPropositionConversion,
  isFtpeMember, loading,
  selectedActivitesPIB = [], selectedActivitesGO = [],
  selectedActivites2nd = [], selectedActivitesTP = [],
  montantsPersonnalises, setMontantsPersonnalises,
  getMontantsFinals, getTaxesFinals,
  taxesPersonnalisees, setTaxesPersonnalisees,
  isSuperAdmin, isAdminOrSuperAdmin,
  validitePersonnalisee, setValiditePersonnalisee,
  updateLigneTaxe, supprimerLigneTaxe, ajouterLigneTaxe,
  remiseSolidaireNegociee = null,
  onEcheancierPlanChange = null} = props;
  const [signatureModalOpen, setSignatureModalOpen] = React.useState(false);
  const defaultEmailForSignature = (
    propositionConversion?.membreEmail
    || (user && user.role === 'member' ? user.email : '')
    || ''
  );
  const defaultNameForSignature = (
    propositionConversion?.membreName
    || (user && user.role === 'member' ? `${user.prenom || ''} ${user.nom || ''}`.trim() : '')
    || ''
  );
  const sub = {
  resultat, modeCalcul, modeSimulateur, user, formData, contratParent,
  walletBalance, creditCostPdf, hasEnoughCredits, loadingDevis, handleDownloadDevisSimulation, handleSouscrire,
  handleCreerAvenant, propositionConversion, handleSouscrireFromProposition, dismissPropositionConversion, isFtpeMember, loading,
  selectedActivitesPIB, selectedActivitesGO, selectedActivites2nd, selectedActivitesTP, montantsPersonnalises, setMontantsPersonnalises,
  getMontantsFinals, getTaxesFinals, taxesPersonnalisees, setTaxesPersonnalisees, isSuperAdmin, isAdminOrSuperAdmin,
  validitePersonnalisee, setValiditePersonnalisee, updateLigneTaxe, supprimerLigneTaxe, ajouterLigneTaxe, remiseSolidaireNegociee,
  onEcheancierPlanChange,
    signatureModalOpen, setSignatureModalOpen};
  return (
    <>
          {/* Résultats - Design Ultra-Professionnel */}
          <Card id="resultat-simulation" className="shadow-2xl border-0 ring-2 ring-blue-100/50 overflow-hidden">
            <CardHeader className="relative bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/30 border-b-2 border-blue-100">
              {/* Motif de fond subtil */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-0 right-0 w-40 h-40 bg-blue-700 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-indigo-500 rounded-full blur-3xl"></div>
              </div>
              
              <div className="relative flex items-center gap-4">
                <div className="relative">
                  <div className="absolute inset-0 bg-blue-500/20 rounded-2xl blur-lg animate-pulse"></div>
                  <div className="relative p-3 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl shadow-lg">
                    <CheckCircle className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div>
                  <CardTitle className="text-2xl font-bold bg-gradient-to-r from-blue-900 to-indigo-900 bg-clip-text text-transparent">
                    Résultat de la Simulation
                  </CardTitle>
                  <CardDescription className="text-base font-medium text-slate-600 mt-1" data-testid="contribution-solidaire-subtitle">
                    Votre contribution solidaire RCD SOLIDAIRE {
                      modeSimulateur === 'avenant'
                        ? 'AVENANT'
                        : modeCalcul === 'nominative'
                          ? 'NOMINATIVE'
                          : (selectedActivitesPIB.length > 0 && selectedActivitesGO.length === 0 && selectedActivites2nd.length === 0 && selectedActivitesTP.length === 0)
                            ? 'PIB'
                            : 'BATICO'
                    }
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent className="pt-6">
              {!resultat ? (
                <div className="text-center py-16 text-slate-500">
                  <div className="relative inline-block mb-6">
                    <div className="absolute inset-0 bg-blue-100 rounded-full blur-2xl opacity-50"></div>
                    <Calculator className="relative h-16 w-16 mx-auto text-blue-300" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">
                    Aucun résultat pour le moment
                  </h3>
                  <p className="text-sm">Renseignez vos informations et cliquez sur "Calculer ma contribution" pour obtenir votre simulation</p>
                </div>
              ) : resultat.requires_manual_validation ? (
                <div className="py-8" data-testid="resultat-validation-manuelle">
                  <div className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 border-2 border-amber-300 rounded-3xl p-8 shadow-xl">
                    <div className="absolute top-0 right-0 w-40 h-40 bg-amber-200/40 rounded-full blur-3xl -translate-y-20 translate-x-20"></div>
                    <div className="relative z-10">
                      <div className="flex items-start gap-4 mb-5">
                        <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-lg">
                          <AlertTriangle className="h-8 w-8 text-white" />
                        </div>
                        <div className="flex-1">
                          <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-200/60 rounded-full mb-2">
                            <span className="text-[11px] font-bold text-amber-900 uppercase tracking-widest">
                              ⛔ Calcul automatique impossible
                            </span>
                          </div>
                          <h3 className="text-2xl font-bold text-amber-900">
                            Validation manuelle requise
                          </h3>
                          <p className="text-sm text-amber-800 mt-1">
                            Classification : <strong>{resultat.classe_dossier || resultat.statut}</strong>
                            {resultat.score_global !== undefined && resultat.score_global !== null && (
                              <> · Score global : <strong>{resultat.score_global}</strong></>
                            )}
                          </p>
                        </div>
                      </div>

                      {resultat.message && (
                        <div className="mb-4 p-4 bg-white/70 rounded-xl border border-amber-200">
                          <p className="text-sm text-slate-700 leading-relaxed">{resultat.message}</p>
                        </div>
                      )}

                      {resultat.motifs?.length > 0 && (
                        <div className="bg-white rounded-xl border border-rose-200 p-4">
                          <p className="text-xs font-bold text-rose-700 uppercase tracking-wide mb-2">
                            Motifs de blocage ({resultat.motifs.length})
                          </p>
                          <ul className="space-y-1.5">
                            {resultat.motifs.map((m, i) => (
                              <li key={i} className="flex items-start gap-2 text-sm text-rose-900" data-testid={`resultat-motif-${i}`}>
                                <span className="flex-shrink-0 mt-0.5">⛔</span>
                                <span>{m}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      <div className="mt-5 flex items-center gap-2 text-xs text-amber-700">
                        <Shield className="h-3.5 w-3.5" />
                        <span>Un opérateur reprendra contact pour finaliser l'analyse de votre dossier.</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-6">
                  {/* Badge "Remise solidaire négociée" — visible quand pré-paramétrée au niveau du membre */}
                  {remiseSolidaireNegociee?.enabled && (
                    <div
                      className="flex items-center gap-3 p-3 bg-gradient-to-r from-emerald-200 to-teal-200 border-2 border-emerald-400 rounded-xl"
                      data-testid="remise-solidaire-negociee-badge"
                    >
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-emerald-600 text-white flex items-center justify-center shadow-sm">
                        <Coins className="h-5 w-5" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-bold uppercase tracking-wide text-emerald-700">
                          Remise solidaire négociée appliquée automatiquement
                        </p>
                        <p className="text-sm font-semibold text-emerald-900 mt-0.5">
                          {[
                            remiseSolidaireNegociee.remise_solidaire_max_pct > 0
                              ? `-${remiseSolidaireNegociee.remise_solidaire_max_pct}%`
                              : null,
                            remiseSolidaireNegociee.remise_solidaire_max_eur > 0
                              ? `-${remiseSolidaireNegociee.remise_solidaire_max_eur.toLocaleString('fr-FR')} €`
                              : null,
                          ]
                            .filter(Boolean)
                            .join(' et ')}
                          {remiseSolidaireNegociee.annexe_numero && (
                            <span
                              className="ml-2 text-xs font-semibold px-2 py-0.5 bg-emerald-600 text-white rounded"
                              data-testid="remise-solidaire-annexe-numero"
                            >
                              Annexe {remiseSolidaireNegociee.annexe_numero}
                            </span>
                          )}
                        </p>
                        {remiseSolidaireNegociee.comment && (
                          <p className="text-xs italic text-emerald-700 mt-0.5">
                            « {remiseSolidaireNegociee.comment} »
                          </p>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Aperçu du titre de l'attestation */}
                  <div className="flex items-center gap-3 p-3 bg-slate-200 border-2 border-slate-400 rounded-xl" data-testid="attestation-title-preview">
                    <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${
                      modeSimulateur === 'avenant'
                        ? 'bg-purple-100 text-purple-700'
                        : modeCalcul === 'nominative' 
                          ? 'bg-amber-100 text-amber-700' 
                          : (selectedActivitesPIB.length > 0 && selectedActivitesGO.length === 0 && selectedActivites2nd.length === 0 && selectedActivitesTP.length === 0)
                            ? 'bg-teal-100 text-teal-700'
                            : 'bg-blue-100 text-blue-700'
                    }`}>
                      <FileText className="h-5 w-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">Document qui sera généré</p>
                      <p className="text-sm font-bold text-slate-800 truncate" data-testid="attestation-title-text">
                        PROPOSITION ESS RCDS {
                          modeSimulateur === 'avenant'
                            ? 'AVENANT'
                            : modeCalcul === 'nominative' 
                              ? 'NOMINATIVE' 
                              : (selectedActivitesPIB.length > 0 && selectedActivitesGO.length === 0 && selectedActivites2nd.length === 0 && selectedActivitesTP.length === 0)
                                ? 'PIB'
                                : 'BATICO'
                        }
                      </p>
                    </div>
                  </div>

                  {/* Montant principal - Design Ultra-Premium */}
                  <div className="relative overflow-hidden bg-gradient-to-br from-blue-700 via-blue-800 to-indigo-900 text-white p-10 rounded-3xl shadow-2xl ring-4 ring-blue-100/20">
                    {/* Animation de fond complexe */}
                    <div className="absolute inset-0">
                      <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full blur-3xl -translate-y-36 translate-x-36 animate-pulse"></div>
                      <div className="absolute bottom-0 left-0 w-56 h-56 bg-blue-300/10 rounded-full blur-3xl translate-y-28 -translate-x-28 animate-pulse" style={{animationDelay: '1s'}}></div>
                      <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-indigo-300/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 animate-pulse" style={{animationDelay: '2s'}}></div>
                    </div>
                    
                    {/* Grille décorative */}
                    <div className="absolute inset-0 opacity-5">
                      <div className="w-full h-full" style={{
                        backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                        backgroundSize: '20px 20px'
                      }}></div>
                    </div>
                    
                    <div className="relative z-10">
                      <div className="flex items-start justify-between mb-6">
                        <div>
                          <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/15 backdrop-blur-sm rounded-full mb-3">
                            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                            <p className="text-xs font-bold text-white uppercase tracking-widest">
                              Contribution Solidaire
                            </p>
                          </div>
                          <p className="text-2xl font-bold text-white/95">
                            Montant
                          </p>
                        </div>
                        <div className="relative">
                          <div className="absolute inset-0 bg-white/20 rounded-2xl blur-xl animate-pulse"></div>
                          <div className="relative p-4 bg-white/20 backdrop-blur-md rounded-2xl border border-white/30 shadow-xl">
                            <CheckCircle className="h-10 w-10" />
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex items-baseline gap-3 mb-4">
                        <span className="text-7xl md:text-8xl font-black tracking-tighter drop-shadow-2xl">
                          {(montantsPersonnalises.enabled && getMontantsFinals()?.montant_ttc) 
                            ? getMontantsFinals().montant_ttc.toLocaleString('fr-FR', {maximumFractionDigits: 2})
                            : resultat.montant_ttc?.toLocaleString('fr-FR')}
                        </span>
                        <span className="text-4xl font-black text-blue-100 mb-2">€</span>
                      </div>
                      
                      {/* Badge montants personnalisés */}
                      {montantsPersonnalises.enabled && getMontantsFinals()?.is_personnalise && (
                        <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-500/30 backdrop-blur-sm rounded-full mb-4 border border-emerald-300/50">
                          <span className="text-xs font-bold text-emerald-100">✨ Montants personnalisés par Super Admin</span>
                          {getMontantsFinals()?.remise > 0 && (
                            <span className="text-xs font-bold text-red-200 bg-red-500/30 px-2 py-0.5 rounded-full">-{getMontantsFinals().remise}%</span>
                          )}
                        </div>
                      )}

                      {/* Plancher contributif appliqué */}
                      {resultat.plancher_contributif?.applique && (
                        <div
                          className="inline-flex items-center gap-2 px-3 py-1.5 bg-amber-400/30 backdrop-blur-sm rounded-full mb-4 border border-amber-200/50"
                          data-testid="plancher-contributif-banner"
                          title={`Le calcul aurait donné ${resultat.plancher_contributif.montant_ht_origine?.toLocaleString('fr-FR')} € HT, ajusté au plancher de ${resultat.plancher_contributif.seuil?.toLocaleString('fr-FR')} € HT (RCDS ${resultat.plancher_contributif.type_rcds}).`}
                        >
                          <span className="text-xs font-bold text-amber-50">
                            ⚖️ Cotisation au plancher contributif
                          </span>
                          <span className="text-[10px] text-amber-100 bg-amber-600/40 px-2 py-0.5 rounded-full font-mono">
                            min {resultat.plancher_contributif.seuil?.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € HT
                            {resultat.plancher_contributif.seuil_annuel != null && ` (proratisé, annuel ${resultat.plancher_contributif.seuil_annuel.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €)`}
                          </span>
                        </div>
                      )}
                      
                      <div className="h-1 w-32 bg-gradient-to-r from-white/40 via-white/60 to-transparent rounded-full mb-6"></div>
                      
                      {resultat.periode && (
                        <div className="flex flex-wrap items-center gap-3 pt-6 border-t border-white/20">
                          <div className="flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-md rounded-xl border border-white/30">
                            <span className="text-2xl">📅</span>
                            <span className="font-bold text-lg">{resultat.periode.nombre_jours} jours</span>
                          </div>
                          <div className="flex items-center gap-2 text-lg text-blue-50 font-medium">
                            <span className="text-white/60">→</span>
                            <span className="font-bold text-white">{resultat.periode.montant_journalier?.toLocaleString('fr-FR')} €</span>
                            <span className="text-white/80">/ jour</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Détails */}
                  <div className="space-y-3">
                    <h4 className="font-semibold text-sm text-slate-700">Détail du calcul</h4>
                    
                  <ResultatsMontants {...sub} />
                  <ResultatsAdminPanels {...sub} />
                  <ResultatsActions {...sub} />
                  </div>
                </div>
              )}
            </CardContent>
          </Card>

          {/* V36.12 — Modal d'envoi pour signature électronique */}
          <EnvoiSignatureModal
            open={signatureModalOpen}
            onOpenChange={setSignatureModalOpen}
            devisId={propositionConversion?.devisId}
            defaultEmail={defaultEmailForSignature}
            defaultName={defaultNameForSignature}
          />
    </>
  );
}
